/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomerReceiptSingleResult } from '../models/CustomerReceiptSingleResult';
import type { LotteryCollectionResult } from '../models/LotteryCollectionResult';
import type { LotteryFilter } from '../models/LotteryFilter';
import type { OtherReceiptSingleResult } from '../models/OtherReceiptSingleResult';
import type { ReceiptParams } from '../models/ReceiptParams';
import type { StringCollectionResult } from '../models/StringCollectionResult';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GsoaBuyAndWinService {
    /**
     * Retrieves customer receipts registered to the lottery.
     * Returns registered receipt IDs.
     * @returns StringCollectionResult Receipts have been successfully retrieved.
     * @throws ApiError
     */
    public static getRegisteredReceipts({
        lotteryId,
        apiVersion = 1,
    }: {
        /**
         * Lottery ID.
         */
        lotteryId: number,
        apiVersion?: number,
    }): CancelablePromise<StringCollectionResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/buyAndWin/registration/receipts',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'lotteryId': lotteryId,
            },
            errors: {
                400: `Model validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden.`,
                500: `Unexpected server error.`,
            },
        });
    }
    /**
     * Registers a new receipt for others.
     * <b>Important notice!</b>
     * <br />If an error occurs during validation of input parameters, only one error will be returned for each parameter, and there can be multiple parameters with error, but only one error at a time.
     * @returns OtherReceiptSingleResult Receipt has been successfully registered.
     * @throws ApiError
     */
    public static registerReceipt({
        apiVersion = 1,
        requestBody,
    }: {
        apiVersion?: number,
        /**
         * Request parameters.
         */
        requestBody?: ReceiptParams,
    }): CancelablePromise<OtherReceiptSingleResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v{apiVersion}/gsoa/buyAndWin/registration/other',
            path: {
                'apiVersion': apiVersion,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Model validation error.`,
                401: `Unauthorized.`,
                403: `Invalid recaptcha.`,
                422: `Receipt exists but is not usable for the lottery.`,
                500: `Unexpected server error.`,
            },
        });
    }
    /**
     * Registers a new receipt for loyalty customers.
     * <b>Important notice!</b>
     * <br />If an error occurs during validation of input parameters, only one error will be returned for each parameter, and there can be multiple parameters with error, but only one error at a time.
     * @returns CustomerReceiptSingleResult Receipt has been successfully registered.
     * @throws ApiError
     */
    public static registerCustomerReceipt({
        apiVersion = 1,
        requestBody,
    }: {
        apiVersion?: number,
        /**
         * Request parameters.
         */
        requestBody?: ReceiptParams,
    }): CancelablePromise<CustomerReceiptSingleResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v{apiVersion}/gsoa/buyAndWin/registration/customer',
            path: {
                'apiVersion': apiVersion,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Model validation error.`,
                401: `Unauthorized.`,
                403: `Invalid recaptcha.`,
                422: `Receipt exists but is not usable for the lottery.`,
                500: `Unexpected server error.`,
            },
        });
    }
    /**
     * Retrieves lotteries.
     * @returns LotteryCollectionResult Lotteries have been retrieved.
     * @throws ApiError
     */
    public static getLotteries({
        filter,
        apiVersion = 1,
    }: {
        /**
         * Lottery filter.
         */
        filter: LotteryFilter,
        apiVersion?: number,
    }): CancelablePromise<LotteryCollectionResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/buyAndWin/management/lotteries',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'filter': filter,
            },
            errors: {
                400: `Model validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden.`,
                500: `Unexpected server error.`,
            },
        });
    }
}
